import { useEffect, useRef } from "react";

import { useCookieConsent } from "@punto/frontend-shared/hooks/use-cookie-consent";
import { Trans, useTranslation } from "@punto/frontend-shared/i18n/i18next";
import { COOKIE_POLICY_URL } from "@punto/frontend-shared/utils/cookie-consent";
import { Button } from "@punto/ui/components/button";

export const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const { hasConsent, acceptCookies, rejectCookies } = useCookieConsent();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const acceptButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (hasConsent) {
      dialogRef.current?.close();
    } else {
      dialogRef.current?.show();
      acceptButtonRef.current?.focus();
    }
  }, [hasConsent]);

  if (hasConsent) {
    return null;
  }

  return (
    <dialog
      ref={dialogRef}
      className="animate-in fade-in slide-in-from-bottom-4 fixed inset-x-0 bottom-0 z-50 m-0 flex w-full justify-center border-none bg-transparent p-4 duration-300"
      aria-describedby="cookie-banner-description"
    >
      <div className="flex max-w-3xl flex-col gap-4 rounded-lg border bg-white p-4 shadow-lg sm:flex-row sm:items-center sm:gap-6">
        <p id="cookie-banner-description" className="text-foreground text-sm">
          <Trans
            i18nKey="CookieBanner.message"
            components={{
              linked: (
                <a
                  href={COOKIE_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-4"
                >
                  cookie policy
                </a>
              ),
            }}
          />
        </p>
        <div className="flex shrink-0 gap-2">
          <Button ref={acceptButtonRef} size="sm" onClick={acceptCookies}>
            {t("CookieBanner.accept")}
          </Button>
          <Button variant="outline" size="sm" onClick={rejectCookies}>
            {t("CookieBanner.reject")}
          </Button>
        </div>
      </div>
    </dialog>
  );
};
